import { FormLabel, FormLabelProps } from "@chakra-ui/react"

const ContactFormLabel = ({ children, ...props }: FormLabelProps) => {
  return (
    <FormLabel
      color={"brand.black"}
      fontSize={"2xl"}
      width={{ base: "full", md: "50%" }}
      borderBottomWidth={{ base: 0, md: 1 }}
      borderColor={"gray.100"}
      mt={1}
      _focus={{ color: "brand.primary" }}
      {...props}
    >
      {children}
    </FormLabel>
  )
}

export default ContactFormLabel
